import * as React from 'react'

interface GoogleIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string
}

export function GoogleIcon({ className, ...props }: GoogleIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...props}
    >
      <path fill="#4285F4" d="M21.35 11.1H12v2.9h5.35c-.25 1.45-1.05 2.68-2.26 3.51v2.92h3.65c2.14-1.97 3.38-4.88 3.38-8.33 0-.7-.06-1.38-.17-2z" />
      <path fill="#34A853" d="M12 22c3.06 0 5.63-1.01 7.5-2.75l-3.65-2.92c-1.01.68-2.31 1.08-3.85 1.08-2.96 0-5.47-2-6.37-4.69H1.88v2.98C3.74 19.33 7.56 22 12 22z" />
      <path fill="#FBBC05" d="M5.63 13.72c-.23-.68-.37-1.4-.37-2.14s.13-1.46.37-2.14V6.46H1.88A9.98 9.98 0 0 0 1 11.58c0 1.61.39 3.13 1.08 4.46l3.55-2.32z" />
      <path fill="#EA4335" d="M12 5.38c1.67 0 3.17.58 4.35 1.73l3.26-3.26C17.62 1.99 15.06 1 12 1 7.56 1 3.74 3.67 1.88 7.54l3.75 2.92C6.53 7.39 9.04 5.38 12 5.38z" />
    </svg>
  )
}
